import Logo from '../src/Logo.png';
import './App.css';
import 'linearicons/dist/web-font/style.css';


import Route from '../src/Router/Route';
import { useEffect } from 'react';
import { get } from './ApiServices/ApiServices';
import { useNavigate } from 'react-router-dom';
function App() {
  // const navigate = useNavigate();
  // const ViewState = async () => {
  //   try {
  //     const api = `get-states`;
  //     const response = await get(api);
  //     console.log(response.data)
  //     if (response?.message == "success") {
  //       alert("llllllllllll")
  //     }
  //   } catch (err) {
  //     if (err?.message === "Invalid or expired token" || err?.message === "Invalid Token") {
  //       localStorage.removeItem('token');
  //       navigate('/login');
  //     }
  //     console.error('Errordsfdsfd:', err);
  //   } finally {
  //     console.log("first")
  //   }
  // };
  // useEffect(() => {
  //   ViewState();
  // }, []);


  return (
    <>
      <Route />
    </>
  );
}

export default App;
